import { render, staticRenderFns } from "./Scheme6.vue?vue&type=template&id=1cb0582e&scoped=true"
import script from "./Scheme6.vue?vue&type=script&lang=js"
export * from "./Scheme6.vue?vue&type=script&lang=js"
import style0 from "./Scheme6.vue?vue&type=style&index=0&id=1cb0582e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb0582e",
  null
  
)

export default component.exports